<template>
    <div class="tvprogramm-filter" :class="store.isLoading ? 'is-loading' : ''">
        <h3 class="tvprogramm-headline">Alle Angebote von {{ store.data.label }}</h3>

        <button class="btn btn-outline-info btn-tvprogram"
                :disabled="store.isLoading"
                @click="toggleOptionsVisible">Filtern</button>

        <div class="tvprogramm-filter-overlay"
             :class="optionsVisible ? 'd-block' : ''">

            <div class="tvprogramm-filter-options container">

                <button class="close"
                        @click="toggleOptionsVisible">
                    <i class="fa fa-close"></i>
                </button>

                <h3 class="filter-headline">Filtern</h3>

                <Dropdown
                    :options="store.selects.broadcastTimes.values"
                    v-on:selected="selectedBroadcastTime"
                    v-on:filter=""
                    :disabled="store.isLoading"
                    name="broadcastTime"
                    :maxItem="-1"
                    placeholder="Sendezeit auswählen">
                </Dropdown>

                <Dropdown
                    :options="store.selects.hotelnames.values"
                    v-on:selected="selectedHotelname"
                    v-on:filter=""
                    :disabled="store.isLoading"
                    name="hotelname"
                    :maxItem="-1"
                    placeholder="Hotel auswählen">
                </Dropdown>

                <Dropdown
                    :options="store.selects.destinations.values"
                    v-on:selected="selectedDestination"
                    v-on:filter=""
                    :disabled="store.isLoading"
                    name="destinations"
                    :maxItem="-1"
                    placeholder="Reiseziel auswählen">
                </Dropdown>

                <Dropdown
                    :options="store.selects.orderNumbers.values"
                    v-on:selected="selectedOrdernumber"
                    v-on:filter=""
                    :disabled="store.isLoading"
                    name="orderNumber"
                    :maxItem="-1"
                    placeholder="TV Bestellnummer auswählen">
                </Dropdown>


              <div class="tvprogramm-filter-buttons">
                <button class="btn btn-success reset"
                        @click="resetFilter">
                  Filter zurücksetzen
                </button>

                <button class="btn btn-success show"
                        @click="toggleOptionsVisible">
                  Jetzt ansehen
                </button>
              </div>

            </div>

        </div>
    </div>
</template>

<script>

import {store} from "./TvProgramStore";
import Dropdown from "./Dropdown.vue";

export default {
    name: 'TvProgramFilter',
    data: () => {
        return {
            store,
            optionsVisible: false,
        }
    },
    components: {
        Dropdown
    },
    computed: {},
    created() {
    },
    mounted() {
    },
    methods: {
        toggleOptionsVisible() {
            this.optionsVisible = !this.optionsVisible;
        },
        resetFilter(){
            this.emitter.emit('reset-dropdowns', 'reset');
        },
        selectedBroadcastTime(val) {
            this.store.selects.broadcastTimes.selected = val;
            this.$nextTick(() => {
                this.store.filterData();
            });
        },
        selectedHotelname(val) {
            this.store.selects.hotelnames.selected = val;
            this.$nextTick(() => {
                this.store.filterData();
            });
        },
        selectedDestination(val) {
            this.store.selects.destinations.selected = val;
            this.$nextTick(() => {
                this.store.filterData();
            });
        },
        selectedHost(val) {
            this.store.selects.hosts.selected = val;
            this.$nextTick(() => {
                this.store.filterData();
            });
        },
        selectedOrdernumber(val) {
            this.store.selects.orderNumbers.selected = val;
            this.$nextTick(() => {
                this.store.filterData();
            });
        },
        log(type, val) {
            console.log(type, val);
        }
    }
}
</script>

<style lang="scss">
@import '../../../../../../Private/Scss/variables/variables';

.tvprogramm-filter {
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
    margin-bottom: 20px;
    width: 100%;
    @media screen and (max-width: $lg) {
        width: auto;
        flex-flow: column;
        margin-top: 30px;
    }
    &.is-loading {
        opacity: 0.5;
        cursor: not-allowed !important;
    }
    .tvprogramm-headline {
        font-size: 20px;
        min-width: 340px;
        @media screen and (max-width: $lg) {
            min-width: auto;
            font-size: 18px;
        }
    }
    .btn-outline-info.btn-tvprogram {
        border-radius: 10px;
        color: $mt-orange;
        border-color: $mt-orange;
        margin-left: 10px;
        display: none;
        @media screen and (max-width: $lg) {
            display: block;
            width: 136px;
            border-radius: 20px;
            height: 30px;
            padding: 0;
            margin-left: 0;
        }

        &:hover, &:active, &:focus, &:focus-visible {
            background-color: $mt-orange;
            border-color: $mt-orange;
            box-shadow: none;
            color: #fff;
            outline: none;
        }
    }
    .btn-outline-info:not(:disabled):not(.disabled):active,
    .btn-outline-info:not(:disabled):not(.disabled).active,
    .show > .btn-outline-info.dropdown-toggle,
    .btn-outline-info:not(:disabled):not(.disabled):active:focus,
    .btn-outline-info:not(:disabled):not(.disabled).active:focus,
    .show > .btn-outline-info.dropdown-toggle:focus{
        background-color: $mt-orange;
        border-color: $mt-orange;
        box-shadow: none;
        color: #fff;
        outline: none;
    }
    .tvprogramm-filter-overlay {
        display: flex;
        flex-flow: row wrap;
        justify-content: space-between;
        @media screen and (max-width: $lg) {
            display: none;
            position: fixed;
            background-color: rgba(0,0,0,0.8);
            top: 0;
            left: 0;
            height: 100%;
            z-index: 3;
            width: 100%;
        }
        .tvprogramm-filter-options {
            display: flex;
            flex-flow: row wrap;
            justify-content: flex-start;
            margin: 0 0 20px 0;
            width: auto;
            flex-grow: 1;
            @media screen and (max-width: $lg) {
                background-color: $mt-dark-blue;
                padding: 20px 20px 40px 20px;
                margin: 0;
            }
            .close {
                display: none;
                @media screen and (max-width: $lg) {
                    color: #fff;
                    display: block;
                    position: absolute;
                    right: 10px;
                    top: 10px;
                }
            }
            .filter-headline {
                display: none;
                @media screen and (max-width: $lg) {
                    display: block;
                    color: #fff;
                    font-size: 20px;
                    padding-bottom: 40px;
                }
            }
        }
        .tvprogramm-filter-buttons {
            @media screen and (max-width: $lg) {
                background: #0d476a;
                padding: 20px 20px 10px;
                display: flex;
                flex-flow: row wrap;
                justify-content: space-between;
                border-top: 2px solid #fff;
            }
            .btn-success {
                font-size: 13px;
                @media screen and (max-width: $lg) {
                    width: auto;
                    margin: 0 0 10px 0;
                }
                @media screen and (max-width: $sm) {
                    width: 100%;
                }
                &.show {
                    display: none;
                    @media screen and (max-width: $lg) {
                        display: block;
                    }
                }
            }
        }
    }
}

</style>
